import { reqNonFinishBill, reqTransList, reqReserveList } from '@/api/hailState'
import dayjs from 'dayjs'

/* 舊版的有notify string，目前似乎不需要顯示
function serverNotifyPassenger(arr) {
  if (arr) {
    return arr.length === 1 ? arr[0] : arr[1];
  }
  return "";
} */

function serverName(name) {
  /* 若是客服的名字包含以下幾項則將其移除
  1. line叫車
  2. APP
  3. 客服: */
  const substringsToRemove = ['客服:', 'Line叫車', 'APP']
  const regex = new RegExp(substringsToRemove.join('|'), 'g')
  return name.replace(regex, '')
}

// 取消訂單的客服姓名
function cancelServerName(cancelStr, serverName) {
  if (cancelStr && cancelStr.includes(',')) {
    return cancelStr.split(',')[1]
  }
  return serverName
}

// 訂單回傳狀態的object
function condition(bill) {
  const driverCancelArr = bill.driverInfo.driverCancel
    ? bill.driverInfo.driverCancel.split(',')
    : null

  /* 舊版的有notifyStr
  const serverNotifyStr = serverNotifyPassenger(driverCancelArr); */
  let condition, cancelReason

  if (!bill.billInfo.orderTime && !bill.billInfo.finishTime) {
    ;(condition = '詢車中'), (cancelReason = '')
  } else if (bill.passengerServerInfo.passengerCancel) {
    // 當hover出現乘客取消原因
    condition = '已取消'
    /* const cancelStr = bill.passengerServerInfo.passengerCancel.includes(',')
      ? bill.passengerServerInfo.passengerCancel.split(',')[2]
      : bill.passengerServerInfo.passengerCancel
    cancelReason = `${cancelStr == '' ? '乘客取消' : cancelStr} ${dayjs(
      bill.billInfo.finishTime,
    ).format('YYYY-MM-DD HH:mm:ss')} ${cancelServerName(
      bill.passengerServerInfo.passengerCancel,
      bill.passengerServerInfo.passengerserverName,
    )}` */
    cancelReason = bill.passengerServerInfo.passengerCancel
  } else if (bill.driverInfo.driverCancel && driverCancelArr.length === 1) {
    // 當hover出現司機取消原因
    ;(condition = '已取消'),
      (cancelReason = `${bill.driverInfo.driverCancel} ${dayjs(
        bill.billInfo.finishTime,
      ).format('YYYY-MM-DD HH:mm:ss')} ${cancelServerName(
        bill.passengerServerInfo.passengerCancel,
        bill.passengerServerInfo.passengerserverName,
      )}`)
  } else if (!bill.billInfo.orderTime && bill.billInfo.finishTime) {
    ;(condition = '未有司機接單'), (cancelReason = '')
  } else if (!bill.billInfo.getPassenagerTime && !bill.billInfo.finishTime) {
    ;(condition = '司機已接單'), (cancelReason = '')
  } else if (
    !bill.billInfo.finishTime &&
    !bill.driverInfo.driverCancel &&
    !bill.passengerServerInfo.passengerCancel
  ) {
    ;(condition = '司機已載客'), (cancelReason = '')
  } else if (
    bill.billInfo.finishTime &&
    !bill.driverInfo.driverCancel &&
    !bill.passengerServerInfo.passengerCancel
  ) {
    ;(condition = '已完成'), (cancelReason = '')
  } else if (driverCancelArr.length === 3) {
    // 當hover出現取消原因
    ;(condition = '已取消'),
      (cancelReason = `司機取消 ${dayjs(bill.billInfo.finishTime).format(
        'YYYY-MM-DD HH:mm:ss',
      )} ${cancelServerName(
        bill.passengerServerInfo.passengerCancel,
        bill.passengerServerInfo.passengerserverName,
      )}`)
  } else if (JSON.stringify(bill.driverInfo) === '{}') {
    ;(condition = '司機未接單'), (cancelReason = '')
  } else {
    ;(condition = '異常'), (cancelReason = '')
  }
  return { condition, cancelReason }
}

export default {
  async fetchBillList({ state, commit }) {
    try {
      let res
      if (state.picked === 3) {
        const { result } = await reqNonFinishBill(
          state.kw,
          state.billPaging.npp,
          state.billPaging.currentPage,
        )
        res = result
      } else {
        const { result } = await reqTransList(
          state.kw,
          state.billPaging.npp,
          state.billPaging.currentPage,
          state.task,
        )
        res = result
      }
      if (res === 'err') {
        commit('setBillList', [])
      } else {
        const billListAddCondition = res.billList.map((bill) => {
          // 取消狀態obj
          const status = condition(bill)
          // 修改時間的日期格式
          bill.billInfo.orderTime = bill.billInfo.orderTime
            ? dayjs(bill.billInfo.orderTime).format('YYYY-MM-DD HH:mm:ss')
            : '無司機接單'
          bill.billInfo.getPassenagerTime = bill.billInfo.getPassenagerTime
            ? dayjs(bill.billInfo.getPassenagerTime).format(
                'YYYY-MM-DD HH:mm:ss',
              )
            : null
          return {
            ...bill,
            status,
          }
        })
        commit('setBillList', billListAddCondition)
        commit(
          'setBillPagingTotalPages',
          Math.ceil(res.total / state.billPaging.npp),
        )
        commit('setBillPagingTotalEntries', res.total)
        commit('setLastUpdateTime', dayjs().format('HH:mm:ss'))
        commit('setReserveCount', res.messageCount)
      }
    } catch (e) {
      console.error(e)
    }
  },
  async fetchReserveList({ state, commit }) {
    let reserveList = []
    let totalEntries = 0
    let totalPages = 0
    try {
      const { result } = await reqReserveList(state.reservePaging.currentPage)
      if (result.hasOwnProperty('data')) {
        reserveList = result.data.map((order) => {
          return {
            ...order,
            reservationDate: dayjs(order.reservationDate).format(
              'YYYY-MM-DD HH:mm',
            ),
          }
        })
        totalEntries = result.paging.totalEntries
        totalPages = result.paging.totalPages
      }
      commit('setReserveList', reserveList)
      commit('setReservePagingTotalEntries', totalEntries)
      commit('setReservePagingTotalPages', totalPages)
    } catch (e) {
      console.error(e)
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/hailState/actions.js